const postInsertReschedulePayload = (payload) => {
  const formData = new FormData();

  if (payload.approvalType?.label === 'Tukar Jadwal') {
    formData.append('targetScheduleId', payload.targetScheduleId.id);
    formData.append('targetUserId', payload.host.id);
  } else {
    formData.append('targetUserId', payload.hostChangeHost.id);
  }

  formData.append('typeId', payload?.approvalType?.value);
  formData.append('reason', payload?.reason);

  payload?.files.forEach((file) => formData.append('files', file));

  return formData;
};

export default postInsertReschedulePayload;
